import axios from "axios";

export const getSection4 = async () => {
  return await axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/api/about-page-s4-solution?populate[Solutions][populate]=*`,
    )
    .then((response) => response.data)
    .catch((error) => error);
};
